var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6167 7.77496L16.9501 6.94163C16.6417 6.79163 16.2584 6.90829 16.1084 7.21663C15.9501 7.53329 16.0751 7.90829 16.3834 8.05829L17.7084 8.71663V12.7083L14.5834 12.7166V4.16663C14.5834 2.49996 13.4667 1.66663 12.0834 1.66663H5.41675C4.03341 1.66663 2.91675 2.49996 2.91675 4.16663V17.7083H1.66675C1.32508 17.7083 1.04175 17.9916 1.04175 18.3333C1.04175 18.675 1.32508 18.9583 1.66675 18.9583H15.8334C16.1751 18.9583 16.4584 18.675 16.4584 18.3333C16.4584 17.9916 16.1751 17.7083 15.8334 17.7083H14.5834V13.9666L18.3334 13.9583C18.6834 13.9583 18.9584 13.675 18.9584 13.3333V8.33329C18.9584 8.09996 18.8251 7.88329 18.6167 7.77496ZM5.00008 5.74163C5.00008 4.58329 5.70841 4.16663 6.57508 4.16663H10.9334C11.7917 4.16663 12.5001 4.58329 12.5001 5.74163V6.76663C12.5001 7.91663 11.7917 8.33329 10.9251 8.33329H6.57508C5.70841 8.33329 5.00008 7.91663 5.00008 6.75829V5.74163ZM5.41675 10.2083H7.91675C8.25841 10.2083 8.54175 10.4916 8.54175 10.8333C8.54175 11.175 8.25841 11.4583 7.91675 11.4583H5.41675C5.07508 11.4583 4.79175 11.175 4.79175 10.8333C4.79175 10.4916 5.07508 10.2083 5.41675 10.2083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceListActive);
export default __webpack_public_path__ + "static/media/device-list-active.3bc4ec18c1cb1864a20c5169632af9b5.svg";
export { ForwardRef as ReactComponent };